import { VISITOR_KEY_PREFIXES, VISITOR_LOCALE_INFO } from '../../schemas/languages.js';
import { enGB } from '../en-GB.js';
import { arVisitor } from './ar.js';
import { cyVisitor } from './cy.js';
import { deVisitor } from './de.js';
import { esVisitor } from './es.js';
import { frVisitor } from './fr.js';
import { itVisitor } from './it.js';
import { plVisitor } from './pl.js';
import { ptVisitor } from './pt.js';
import { roVisitor } from './ro.js';
export const VISITOR_CATALOGUES = {
    fr: frVisitor,
    de: deVisitor,
    es: esVisitor,
    pl: plVisitor,
    ro: roVisitor,
    pt: ptVisitor,
    it: itVisitor,
    cy: cyVisitor,
    ar: arVisitor,
};
export const VISITOR_LOCALE_REGISTRY = {
    'en-GB': { status: 'checked' },
    fr: { status: 'draft' },
    de: { status: 'draft' },
    es: { status: 'draft' },
    pl: { status: 'draft' },
    ro: { status: 'draft' },
    pt: { status: 'draft' },
    it: { status: 'draft' },
    cy: { status: 'draft' },
    ar: { status: 'draft' },
};
export const isVisitorKey = (key) => VISITOR_KEY_PREFIXES.some((p) => key.startsWith(p));
export function visitorLocaleStatus(locale) {
    return VISITOR_LOCALE_REGISTRY[locale].status;
}
/** True if the locale may be offered: checked locales always, draft locales only where the platform allows drafts. */
export function isLocaleAllowed(locale, allowDrafts) {
    return visitorLocaleStatus(locale) === 'checked' || allowDrafts;
}
/** Keeps the requested locales that are allowed, without duplicates, in the order given. */
export function filterOfferedLocales(requested, allowDrafts) {
    return [...new Set(requested)].filter((l) => isLocaleAllowed(l, allowDrafts));
}
/** The first locale of an Accept-Language header that is in `offered` (matches `fr-CA` to `fr`, `en` to `en-GB`). */
export function pickFromAcceptLanguage(header, offered) {
    if (!header)
        return null;
    const wanted = header
        .split(',')
        .map((part) => {
        const [tag = '', ...params] = part.trim().split(';');
        const q = params.map((p) => /^\s*q=([\d.]+)/.exec(p)?.[1]).find(Boolean);
        return { tag: tag.trim().toLowerCase(), q: q === undefined ? 1 : Number(q) };
    })
        .filter((w) => w.tag && w.tag !== '*' && Number.isFinite(w.q) && w.q > 0)
        .sort((a, b) => b.q - a.q);
    for (const w of wanted) {
        const base = w.tag.split('-')[0];
        const hit = offered.find((o) => o.toLowerCase() === w.tag) ?? offered.find((o) => o.toLowerCase().split('-')[0] === base);
        if (hit)
            return hit;
    }
    return null;
}
/** All visitor-prefixed messages for a locale, completed from en-GB so a device can work offline in that language. */
export function visitorMessages(locale) {
    const out = {};
    for (const [k, v] of Object.entries(enGB))
        if (isVisitorKey(k))
            out[k] = v;
    if (locale !== 'en-GB')
        for (const [k, v] of Object.entries(VISITOR_CATALOGUES[locale]))
            if (isVisitorKey(k))
                out[k] = v;
    return out;
}
/** Entry for a picker or kiosk config: code, name in its own language, text direction. */
export function visitorLocaleOption(code) {
    const info = VISITOR_LOCALE_INFO[code];
    return { code, endonym: info.endonym, dir: info.dir };
}
//# sourceMappingURL=index.js.map